import useQuery from '@hooks/useQuery'

import {
  GetPublishPreviewDocument,
  type GetPublishPreviewQuery,
} from '@frontend/graphql/queries/publishPreview.generated'

export type PublishPreview = NonNullable<GetPublishPreviewQuery['event']['roster']>['publishPreview']
export type PublishRecipient = PublishPreview['recipients'][number]

type UsePublishPreviewQueryProps = {
  eventId: string
  shiftIds?: string[]
}

export const usePublishPreviewQuery = ({ eventId, shiftIds }: UsePublishPreviewQueryProps) => {
  const { data, isLoading, isError } = useQuery<GetPublishPreviewQuery>({
    key: ['publishPreview', eventId, shiftIds ? shiftIds.join(',') : 'all'],
    query: GetPublishPreviewDocument,
    variables: { eventId, shiftIds },
    alwaysFresh: true,
  })

  return { preview: data?.event.roster?.publishPreview ?? null, isLoading, isError }
}
